import React from "react";
import { CoRetrieveDocumentId } from "../../components/generic/CoRetrieveDocumentId";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { DocumentProperties } from "../../components/cpm/DocumentProperties/DocumentProperties";
export const DocumentPropertiesPage: React.FunctionComponent = () => {
  return (
    <CoRetrieveDocumentId>
      {(coObject) =>
        coObject && coObject.documentId ? (
          <DocumentProperties idPartRoot={coObject.documentId} />
        ) : (
          <DocumentNotValidError />
        )
      }
    </CoRetrieveDocumentId>
  );
};
